var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"publicationWraper",attrs:{"id":"publicationTrackWraper"}})
}
var staticRenderFns = []

export { render, staticRenderFns }